import type { CompletedResource } from '../types/completed-resources';
import type { ResourceResponse } from '../types/resource-response';
import { appletMapper } from './applet-mapper';
import { genericMapper } from './generic-mapper';
import { geniallyMapper } from './genially-mapper';
import { geogebraMapper } from './geogebra-mapper';
import { pdfMapper } from './pdf-mapper';
import { responseMapper } from './response-mapper';
import sessionMapper from './session-mapper';
import { videoMapper } from './video-mapper';

export type Params = {
  response: ResourceResponse;
  locale: string;
  completedResources?: CompletedResource[];
  isStudent?: boolean;
  isBloqued?: boolean;
};

export const resourceMapper = ({
  response,
  locale,
  completedResources,
  isStudent = false,
}: Params) => {
  const mappedResponse = responseMapper(response);
  const { type } = mappedResponse;

  const isBloqued = !!isStudent && mappedResponse.visibility !== 'visible';

  switch (type) {
    case 'session':
      return sessionMapper({
        response: mappedResponse,
        locale,
        completedResources,
        isStudent,
      });
    case 'vimeo':
      return videoMapper(mappedResponse, locale, isBloqued, isStudent);
    case 'geogebra':
      return geogebraMapper(mappedResponse, locale, isBloqued, isStudent);
    case 'applet':
      return appletMapper({
        response: mappedResponse,
        locale,
        isBloqued,
        isStudent,
      });
    case 'pdf':
      return pdfMapper({
        locale,
        isBloqued,
        response: mappedResponse,
        completedResources,
        isStudent,
      });
    case 'genially':
      return geniallyMapper({
        locale,
        response,
      });
    case 'generic':
      return genericMapper({
        response,
        locale,
      });
    default:
      return undefined;
  }
};
